import React, {useState, useEffect, useRef} from "react";
import SelectCompany from "./SelectCompany";
import {createRoot} from "react-dom/client";
import AddressSelector from "./AddressSelector";
import UniversalAddressModal from "./UniversalAddressModal";
import useCompanyLocations from "./useCompanyLocations";

export default function BillingContainer({billing, countries, ajax_url, nonce}) {
    const [selectedCompanyID, setSelectedCompanyID] = useState(null);

    // Billing hook
    const {
        locations: billingAddresses,
        selected: selectedBilling,
        selectedID: selectedBillingID,
        setSelectedID: setSelectedBillingID,
        addLocation: addBillingAddress
    } = useCompanyLocations(billing, selectedCompanyID, "billing");

    // Shipping hook
    const {
        locations: shippingAddresses,
        selected: selectedShipping,
        selectedID: selectedShippingID,
        setSelectedID: setSelectedShippingID,
        addLocation: addShippingAddress
    } = useCompanyLocations(billing, selectedCompanyID, "shipping");

    const modalRef = useRef();

    useEffect(() => {
        const firstCompanyId = Object.keys(billing)?.[0];
        if (firstCompanyId) setSelectedCompanyID(firstCompanyId);
    }, [billing]);

    // Dodaj nov billing naslov
    const handleAddNewBilling = () => {
        modalRef.current.openModal({
            type: "billing",
            companyID: selectedCompanyID,
            defaultValues: selectedBilling,
            onSaved: (newAddress) => addBillingAddress(newAddress)
        });
    };

    // Dodaj nov shipping naslov
    const handleAddNewShipping = () => {
        modalRef.current.openModal({
            type: "shipping",
            companyID: selectedCompanyID,
            defaultValues: selectedShipping,
            onSaved: (newAddress) => addShippingAddress(newAddress)
        });
    };

    return (
        <>
            <h3>Izbira podjetja</h3>
            <SelectCompany billing={billing} onSelect={setSelectedCompanyID}/>

            <h3>Podatki plačnika</h3>
            <AddressSelector
                locations={billingAddresses}
                selectedID={selectedBillingID}
                setSelectedID={setSelectedBillingID}
                countries={countries}
                onAddNew={handleAddNewBilling}
                addLabel="Dodaj plačnika"
            />

            <h3>Dostava na naslov</h3>
            <AddressSelector
                locations={shippingAddresses}
                selectedID={selectedShippingID}
                setSelectedID={setSelectedShippingID}
                countries={countries}
                onAddNew={handleAddNewShipping}
                addLabel="Dodaj dostavni naslov"
            />

            {/* Hidden inputi za billing */}
            {selectedBilling && (
                <>
                    <input type="hidden" id="billing_company" name="billing_company" value={selectedBilling.company}/>
                    <input type="hidden" id="billing_ddv" name="billing_ddv" value={selectedBilling.ddv}/>
                    <input type="hidden" id="billing_address_1" name="billing_address_1" value={selectedBilling.address_1}/>
                    <input type="hidden" id="billing_city" name="billing_city" value={selectedBilling.city}/>
                    <input type="hidden" id="billing_postcode" name="billing_postcode" value={selectedBilling.postcode}/>
                    <input type="hidden" id="billing_country" name="billing_country" value={selectedBilling.country}/>
                    <input type="hidden" id="billing_phone" name="billing_phone" value={selectedBilling.phone}/>
                    <input type="hidden" id="billing_sm_name" name="billing_sm_name" value={selectedBilling.sm_name}/>


                </>
            )}

            {/* Hidden inputi za shipping */}
            {selectedShipping && (
                <>
                    <input type="hidden" id="shipping_company" name="shipping_company" value={selectedShipping.company}/>
                    <input type="hidden" id="shipping_address_1" name="shipping_address_1" value={selectedShipping.address_1}/>
                    <input type="hidden" id="shipping_city" name="shipping_city" value={selectedShipping.city}/>
                    <input type="hidden" id="shipping_postcode" name="shipping_postcode" value={selectedShipping.postcode}/>
                    <input type="hidden" id="shipping_country" name="shipping_country" value={selectedShipping.country}/>
                </>
            )}

            <UniversalAddressModal ref={modalRef} countries={countries}/>
        </>
    );
}

const container = document.getElementById('ekoda-billing');

if (container) {
    const root = createRoot(container);
    root.render(
        <BillingContainer
            countries={billing.countries}
            billing={billing.billing}
            ajax_url={billing.ajax_url}
            nonce={billing.nonce}
        />
    );
}